import getLatestCategoryPath from '../../constants/legacy/getLatestCategoryPath';
import categoryUrl from '../../utils/categoryUrl';

const getEmptyDataRedirect = (params, data, errors) => {
  if (errors && !data) return '/';
  const { categoryName } = params || {};
  if (!data) return false;
  if (!categoryName) return '/';

  const { categories: { edges: [{ node: dataObj } = {}] = {} } = {} } = data;

  if (!dataObj) return '/';

  const { name } = dataObj;

  if (!name) return '/';

  return false;
};

const getCategoryRedirects = params => {
  const { categoryName = '' } = params || {};

  if (!categoryName) return '/';

  const redirectCat = getLatestCategoryPath(categoryName);

  return redirectCat ? categoryUrl(redirectCat) : false;
};

const redirects = ({ params, data, errors }) => {
  const redirectArray = [
    getCategoryRedirects(params),
    getEmptyDataRedirect(params, data, errors),
  ];

  return redirectArray.find(url => url);
};

export default redirects;
